import { z } from 'zod';

// REQUESTS
export interface InvoiceGetPdfRequest {
  invoiceNumber: string;
  source: string;
  invoiceDate: string;
  eSoftId: string;
  soldToId: string;
}

export interface InvoiceQueryRequest extends InvoiceQueryFilter {
  pageNumber: number;
  pageSize: number;
  sortingColumn: string;
  sortingType: string;
}

export interface InvoiceQueryFilter {
  soldToId: string;
  invoiceType?: string;
  invoiceNumber?: string;
  currency?: string;
  invoiceDateFrom?: string;
  invoiceDateTo?: string;
  invoiceNetAmountFrom?: number;
  invoiceNetAmountTo?: number;
}

export const InvoiceQueryRecordSchema = z.object({
  eSoftId: z.string().regex(/\d+/),
  soldToId: z.string().regex(/\d+/),
  invoiceNumber: z.string().regex(/\d+/),
  invoiceDate: z.string().regex(/\d{4}-\d{2}-\d{2}/),
  invoiceType: z.enum(["CR","IN"]),
  currency: z.string().min(2),
  netAmount: z.number(),
  vatAmount: z.number(),
  totalAmount: z.number(),
  source: z.string(),
});

export const InvoiceQueryResponseSchema = z.object({
  items: InvoiceQueryRecordSchema.required().array(),
  totalItems: z.number().min(0).int(),
});

export type InvoiceQueryResponseRecord = z.infer<typeof InvoiceQueryRecordSchema>;
export type InvoiceQueryResponse = z.infer<typeof InvoiceQueryResponseSchema>;
